export default {
  // Page titles
  'pages.tenant.package.title': 'Tenant Packages',
  'pages.tenant.package.subtitle': 'Manage subscription plans and pricing',

  // Search
  'pages.tenant.package.search.placeholder':
    'Search package name, package code...',
  'pages.tenant.package.search': 'Search',
  'pages.tenant.package.reset': 'Reset',

  // Status (filter & card tag)
  'pages.tenant.package.status.placeholder': 'Status',
  'pages.tenant.package.status.all': 'All',
  'pages.tenant.package.status.enabled': 'Enabled',
  'pages.tenant.package.status.disabled': 'Disabled',

  // Card display
  'pages.tenant.package.deviceCount': 'Devices',
  'pages.tenant.package.storeCount': 'Stores',
  'pages.tenant.package.unlimited': 'Unlimited',
  'pages.tenant.package.subscriberCount': 'Subscribers',
  'pages.tenant.package.dayUnit': 'days',
  'pages.tenant.package.empty': 'No package data available',

  // Delete
  'pages.tenant.package.deleteConfirm': 'Are you sure to delete this package?',
  'pages.tenant.package.message.deleteSuccess': 'Deleted successfully',

  // Add
  'pages.tenant.package.addTitle': 'Add Package',
  'pages.tenant.package.add': 'Add Package',
  'pages.tenant.package.message.addSuccess': 'Added successfully',

  // Edit
  'pages.tenant.package.editTitle': 'Edit Package',
  'pages.tenant.package.edit': 'Edit',
  'pages.tenant.package.message.editSuccess': 'Updated successfully',
  'pages.tenant.package.save': 'Save',
  'pages.tenant.package.cancel': 'Cancel',

  // Divider
  'pages.tenant.package.divider.basicInfo': 'Basic Information',
  'pages.tenant.package.divider.resourceLimit': 'Resource Limits',
  'pages.tenant.package.form.resourceLimitHint':
    'Entering 0 for store count or device count means unlimited.',
  'pages.tenant.package.divider.pricing': 'Pricing',
  'pages.tenant.package.divider.otherSettings': 'Other Settings',

  // Form
  'pages.tenant.package.form.packageName': 'Package Name',
  'pages.tenant.package.form.packageNameRequired': 'Please enter package name',
  'pages.tenant.package.form.packageCode': 'Package Code',
  'pages.tenant.package.form.packageCodeRequired': 'Please enter package code',
  'pages.tenant.package.form.packageCodePattern':
    'Only letters, numbers and underscores are allowed',
  'pages.tenant.package.form.description': 'Description',
  'pages.tenant.package.form.descriptionPlaceholder':
    'Briefly describe the features and applicable scenarios of the package',
  'pages.tenant.package.form.maxStores': 'Max Stores',
  'pages.tenant.package.form.maxStoresRequired': 'Please enter max stores',
  'pages.tenant.package.form.maxDevices': 'Max Devices',
  'pages.tenant.package.form.maxDevicesRequired': 'Please enter max devices',
  'pages.tenant.package.form.price': 'Package Price',
  'pages.tenant.package.form.priceRequired': 'Please enter package price',
  'pages.tenant.package.form.trialDays': 'Usage Days',
  'pages.tenant.package.form.trialDaysPlaceholder': 'Enter days',
  'pages.tenant.package.form.trialDaysRequired': 'Please enter usage days',
  'pages.tenant.package.form.enablePackage': 'Enable Package',
  'pages.tenant.package.form.switchOn': 'On',
  'pages.tenant.package.form.switchOff': 'Off',
  'pages.tenant.package.form.disableHint':
    'Tenants will not be able to select this package when disabled',
  'pages.tenant.package.form.sort': 'Sort',
  'pages.tenant.package.form.sortPlaceholderAdd': 'Defaults to 0 if left empty',
  'pages.tenant.package.form.sortPlaceholderEdit':
    'Leave empty to keep the current value',
  'pages.tenant.package.form.sortTooltip':
    'Smaller values rank first; packages with the same sort value are listed by creation time, newest first',
  'pages.tenant.package.form.input': 'Please enter',
};
